/* eslint-disable no-shadow */
/* eslint-disable react/jsx-no-bind */
/* eslint-disable max-len */
import React, { useEffect, useState } from "react";
import { useMediaQuery } from "react-responsive";
import PropTypes from "prop-types";
import {
  FormControl,
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup,
} from "@mui/material";


import styled from "styled-components";
import { useSelections } from "../../../context/Selections";
import KpiCard from "../../../components/KpiCard/KpiCard";
import NativeObject from "../../../components/NativeObject/NativeObject";
import Card from "../../../components/Cards/Card";

const LayoutCardWrapper = styled.div`
  border-radius: 16px;
  display: flex;
  width: 100%;
  padding: 10px;
`;

const LayoutCardsWrapper = styled("div")({
  alignItems: "center",
  display: "flex",
  flexDirection: "column",
  height: "94%",
  justifyContent: "flex-start",
  width: "100%",
});

function DistribuidoresDesktop({ app, config }) {
  const notFullHd = useMediaQuery({ query: "(max-width: 1536px)" });

  const [selectedValueCargo, setSelectedValueCargo] = useState("Gerente Geral");

  const { selections } = useSelections();

  const [selectedGroup, setSelectedGroup] = useState("");
  const [singleGroupView, setSingleGroupView] = useState(false);

  useEffect(() => {
    if (app) {
      // update title with selected distributor (when only 1 is selected)
      const cargos = selections.length
        ? selections.find((s) => s.qField === "Tipo_Analise")
        : null;
      const distributors = selections.length
        ? selections.find((s) => s.qField === "Desc_Pasta")
        : null;

      setSelectedValueCargo(cargos?.qSelected);
      setSelectedGroup(
        distributors
          ? distributors?.qSelectedCount === 1
            ? `: ${distributors.qSelected}`
            : ""
          : ""
      );
      setSingleGroupView(distributors?.qSelectedCount === 1);
    }
  }, [app, selections]);

  const handleChange = (event) => {
    app.field("Tipo_Analise").selectMatch(event.target.value, true);
    setSelectedValueCargo(event.target.value);
  };

  return (

        <LayoutCardsWrapper>
          <LayoutCardWrapper>
            <Card
              app={app}
              header={{
                hardTitle: "Escolha o cargo e visualize o ranking em cada KPI",
              }}
              style={{ width: "100%", height: "100%" }}
              className={"container-ranking"}
            >
              <FormControl className="container-form-control">
                <RadioGroup
                  defaultValue="Gerente Geral"
                  row
                  name="row-radio-buttons-group"
                  className="radio-group radio-group-button-export"
                  value={selectedValueCargo}
                  onChange={handleChange}
                >
                  <FormControlLabel
                    value="Gerente Geral"
                    control={
                      <Radio
                        size="small"
                        defaultChecked
                        sx={{
                          color: "#5A2882",
                          "&.Mui-checked": {
                            color: "#5A2882",
                          },
                        }}
                      />
                    }
                    label="Gerente Geral"
                  />

                  <FormControlLabel
                    value="Gerente"
                    control={
                      <Radio
                        size="small"
                        sx={{
                          color: "#5A2882",
                          "&.Mui-checked": {
                            color: "#5A2882",
                          },
                        }}
                      />
                    }
                    label="Gerente"
                  />

                  <FormControlLabel
                    value="Supervisor"
                    control={
                      <Radio
                        size="small"
                        sx={{
                          color: "#5A2882",
                          "&.Mui-checked": {
                            color: "#5A2882",
                          },
                        }}
                      />
                    }
                    label="Supervisor"
                  />

                  <FormControlLabel
                    value="Vendedor Compartilhada"
                    control={
                      <Radio
                        size="small"
                        sx={{
                          color: "#5A2882",
                          "&.Mui-checked": {
                            color: "#5A2882",
                          },
                        }}
                      />
                    }
                    label="Vendedor Compartilhada"
                  />

                  <FormControlLabel
                    value="Vendedor Exclusiva"
                    control={
                      <Radio
                        size="small"
                        sx={{
                          color: "#5A2882",
                          "&.Mui-checked": {
                            color: "#5A2882",
                          },
                        }}
                      />
                    }
                    label="Vendedor Exclusiva"
                  />

                  <FormControlLabel
                    value="Executivo Reppos"
                    control={
                      <Radio
                        size="small"
                        sx={{
                          color: "#5A2882",
                          "&.Mui-checked": {
                            color: "#5A2882",
                          },
                        }}
                      />
                    }
                    label="Executivo Reppos"
                  />
                </RadioGroup>
              </FormControl>

              <Grid
                container
                rowGap={2}
                justifyContent={"space-between"}
                marginTop={"16px"}
                paddingLeft={"10px"}
                flexWrap={"wrap"}
              >
                <Grid item width={"33%"}>
                  <LayoutCardWrapper>
                    <Card
                      app={app}
                      header={{
                        hardTitle: "Faturamento",
                      }}
                      style={{ width: "100%", height: "100%" }}
                      exportTable
                      exportTableId={"XQftTT"}
                      className={"container-table-kpi container-table"}
                    >
                      <KpiCard
                        app={app}
                        valueId={"cJvCT"}
                        goalValueId={"rYJsYF"}
                        percentageId={"bTPKtk"} // no enter
                        hasProgressBar={true}
                        fullView
                      ></KpiCard>

                      <NativeObject
                        app={app}
                        key="XQftTT"
                        reference={{ id: "XQftTT" }}
                        style={{ height: "400px" }}
                      />
                    </Card>
                  </LayoutCardWrapper>
                </Grid>

                <Grid item width={"33%"}>
                  <LayoutCardWrapper>
                    <Card
                      app={app}
                      header={{
                        hardTitle: "%Fat. por Reppos",
                      }}
                      style={{ width: "100%", height: "100%" }}
                      exportTable
                      exportTableId={"kBYtYnL"}
                      className={"container-table-kpi container-table"}
                    >
                      <KpiCard
                        app={app}
                        valueId={"mEYZFdh"}
                        goalValueId={"TjnbYC"}
                        percentageId={"pZJv"}
                        hasProgressBar={true}
                        fullView
                      ></KpiCard>

                      <NativeObject
                        app={app}
                        key="kBYtYnL"
                        reference={{ id: "kBYtYnL" }}
                        style={{ height: "400px" }}
                      />
                    </Card>
                  </LayoutCardWrapper>
                </Grid>

                <Grid item width={"33%"}>
                  <LayoutCardWrapper>
                    <Card
                      app={app}
                      header={{
                        hardTitle: "Positivação",
                      }}
                      style={{ width: "100%", height: "100%" }}
                      exportTable
                      exportTableId={"gbQTUJ"}
                      className={"container-table-kpi container-table"}
                    >
                      <KpiCard
                        app={app}
                        valueId={"tBYGJSx"}
                        goalValueId={"ntpd"}
                        percentageId={"hsutCAd"}
                        hasProgressBar={true}
                        fullView
                      ></KpiCard>

                      <NativeObject
                        app={app}
                        key="gbQTUJ"
                        reference={{ id: "gbQTUJ" }}
                        style={{ height: "400px" }}
                      />
                    </Card>
                  </LayoutCardWrapper>
                </Grid>

                <Grid item width={"33%"}>
                  <LayoutCardWrapper>
                    <Card
                      app={app}
                      header={{
                        hardTitle: "Positivação por Reppos",
                      }}
                      style={{ width: "100%", height: "100%" }}
                      exportTable
                      exportTableId={"wNgXE"}
                      className={"container-table-kpi container-table"}
                    >
                      <KpiCard
                        app={app}
                        valueId={"XjxFW"}
                        goalValueId={"scuPGjJ"}
                        percentageId={"QUmYJ"}
                        hasProgressBar={true}
                        fullView
                      ></KpiCard>

                      <NativeObject
                        app={app}
                        key="wNgXE"
                        reference={{ id: "wNgXE" }}
                        style={{ height: "400px" }}
                      />
                    </Card>
                  </LayoutCardWrapper>
                </Grid>

                <Grid item width={"33%"}>
                  <LayoutCardWrapper>
                    <Card
                      app={app}
                      header={{
                        hardTitle: "MSL",
                      }}
                      style={{ width: "100%", height: "100%" }}
                      exportTable
                      exportTableId={"sMMpcmr"}
                      className={"container-table-kpi container-table"}
                    >
                      <KpiCard
                        app={app}
                        valueId={"KxgfJ"}
                        goalValueId={"nQAhdmk"}
                        percentageId={"gFyFjLL"}
                        hasProgressBar={true}
                        fullView
                      ></KpiCard>

                      <NativeObject
                        app={app}
                        key="sMMpcmr"
                        reference={{ id: "sMMpcmr" }}
                        style={{ height: "400px" }}
                      />
                    </Card>
                  </LayoutCardWrapper>
                </Grid>

                <Grid item width={"33%"}>
                  <LayoutCardWrapper>
                    <Card
                      app={app}
                      header={{
                        hardTitle: "Total Acelera",
                      }}
                      style={{ width: "100%", height: "100%" }}
                      exportTable
                      exportTableId={"KkpDBad"}
                      className={"container-table-kpi container-table"}
                    >
                      <KpiCard
                        app={app}
                        valueId={"QcrrqD"}
                        goalValueId={"AjtyRQ"}
                        percentageId={"AjtyRQ"}
                        hasProgressBar={true}
                        fullView
                      ></KpiCard>

                      <NativeObject
                        app={app}
                        key="KkpDBad"
                        reference={{ id: "KkpDBad" }}
                        style={{ height: "400px" }}
                      />
                    </Card>
                  </LayoutCardWrapper>
                </Grid>
              </Grid>
            </Card>
          </LayoutCardWrapper>
        </LayoutCardsWrapper>

  );
}

DistribuidoresDesktop.defaultProps = {
  app: null,
  config: {},
};

DistribuidoresDesktop.propTypes = {
  app: PropTypes.object,
  config: PropTypes.object,
};

export default DistribuidoresDesktop;
